import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  FormGroup,
  Row,
  Col,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import "./Quotation.scss";

import {
  getQuotationData,
  getMRCodeDetails,
  getPICodeDetails,
} from "../../../store/Quotation/actions";
import { QuotationPdf } from "../../../store/Reports/actions";

import { MRDetailsModel_open } from "../../../store/PurchaseIndent/actions";
import { PIDetailsModel_open } from "../../../store/RequetForQuotation/actions";
import GetPIDetails from "../../GetPIDetails";

import GetMRDetails from "../../GetMRDetails";
import LoadingModel from "../../LoadingModel";
import ItemDetails from "../../ItemDetails";

function PdfViewer({ url }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("📥 PdfViewer: fetching via proxy, url:", url);
    setLoading(true);
    setError(null);

    fetch(url)
      .then((res) => {
        console.log("📥 fetch response status:", res.status);
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        console.log("✅ Blob received, size:", blob.size);
        const objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ PdfViewer fetch error:", err);
        setError(err.message);
        setLoading(false);
      });

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  if (loading) return <p style={{ padding: 10 }}>⏳ Loading PDF...</p>;
  if (error)
    return <p style={{ padding: 10, color: "red" }}>❌ Failed: {error}</p>;

  return (
    <iframe
      src={blobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}

class Quotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      item_details: {},
      selectedOrderLocation: null,
      showImageModal: false,
      fetchedMR: [],
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.tog_static = this.tog_static.bind(this);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));
    this.props.getMRCodeDetails(item.id);
    this.props.getPICodeDetails(item.id);

    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  getPDF() {
    this.props.QuotationPdf(true);
    this.props.history.push("/qreportdoc/" + this.props.match.params.id);
  }

  componentDidMount() {
    if (this.props.match.params.id > 0) {
      this.props.getQuotationData(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.QRowData !== this.props.QRowData &&
      this.props.QRowData?.qitems
    ) {
      this.props.QRowData.qitems.forEach((item) => {
        if (!this.state.fetchedMR.includes(item.id)) {
          this.props.getMRCodeDetails(item.id);
          this.setState((prev) => ({
            fetchedMR: [...prev.fetchedMR, item.id],
          }));
        }
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12} className="p-1 W-100">
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      <div className="float-right ml-2">
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light "
                          onClick={() => {
                            this.getPDF();
                          }}
                        >
                          Download PDF
                        </Button>
                      </div>
                      <Link
                        to="#"
                        onClick={() => this.props.history.goBack()}
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Quotation ({this.props.QRowData.code})
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <Row>
                        <Col md={6}>
                          <div>
                            <ul className="list-style-two p-0 ml-4  ">
                              <li className="clearfix">
                                <span className="ttl">RFQ No:</span>
                                <span className="dtl">
                                  {this.props.QRowData.requestforquotation_code}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">RFQ Date:</span>
                                <span className="dtl">
                                  {moment(
                                    this.props.QRowData
                                      .requestforquotation_date,
                                  ).format("DD-MM-YYYY")}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Vendor Name:</span>
                                <span className="dtl">
                                  {this.props.QRowData.vendor?.name}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div>
                            <ul className="list-style-two p-0 ml-4  ">
                              <li className="clearfix">
                                <span className="ttl">Total Price:</span>
                                <span className="dtl">
                                  {this.props.QRowData.grand_total}
                                </span>
                              </li>
                              <li className="clearfix">
                                <span className="ttl">Delivery Date:</span>
                                <span className="dtl">
                                  {this.props.QRowData.deliverydate}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={this.state.showImageModal ? 8 : 12}
                          xl={this.state.showImageModal ? 8 : 12}
                          className="m-1"
                        >
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 ">
                                    <thead className="bg-light text-center">
                                      <tr>
                                        <th className="nowrap">S.No</th>
                                        <th className="nowrap text-center">
                                          MR Details
                                        </th>
                                        <th className="nowrap text-center">
                                          PI Details
                                        </th>
                                        <th className="nowrap">Item Images</th>
                                        <th
                                          style={{
                                            minWidth: "220px",
                                          }}
                                        >
                                          Item Name
                                        </th>
                                        <th
                                          style={{
                                            width: "220px",
                                          }}
                                        >
                                          Order Location
                                        </th>
                                        <th className="nowrap">Quantity</th>
                                        {/* <th className="nowrap">Qualities</th> */}
                                        <th className="nowrap">
                                          Item Base Price
                                        </th>
                                        <th className="nowrap">
                                          Item Discount(%)
                                        </th>
                                        <th className="nowrap">Item Price</th>
                                        <th className="nowrap">Tax Type</th>
                                        <th className="nowrap">Tax (%)</th>
                                        <th className="nowrap">Gross Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.QRowData.qitems?.map(
                                        (item, key) => (
                                          <React.Fragment key={key}>
                                            <tr key={key}>
                                              <td className="nowrap text-center">
                                                {key + 1}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item?.mrdata?.mrcodes ? (
                                                  <>
                                                    {item?.mrdata?.mrcodes
                                                      .length === 0 ? (
                                                      <>Not found</>
                                                    ) : (
                                                      <>
                                                        <span
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            this.props.MRDetailsModel_open(
                                                              item.mrdata
                                                                .mrcodes[0].id,
                                                            );
                                                          }}
                                                          className="text-primary mr-1"
                                                        >
                                                          <u>
                                                            {
                                                              item.mrdata
                                                                .mrcodes[0].code
                                                            }
                                                          </u>
                                                        </span>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        this.props.getMRCodeDetails(
                                                          item.id,
                                                        );
                                                      }}
                                                      className="text-primary mr-1"
                                                    >
                                                      <u>View</u>
                                                    </span>
                                                  </>
                                                )}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item?.pidata?.picodes ? (
                                                  <>
                                                    {item?.pidata?.picodes
                                                      .length === 0 ? (
                                                      <>Not found</>
                                                    ) : (
                                                      <>
                                                        <span
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            this.props.PIDetailsModel_open(
                                                              item.pidata
                                                                .picodes[0].id,
                                                            );
                                                          }}
                                                          className="text-primary mr-1"
                                                        >
                                                          <u>
                                                            {
                                                              item.pidata
                                                                .picodes[0].code
                                                            }
                                                          </u>
                                                        </span>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        this.props.getPICodeDetails(
                                                          item.id,
                                                        );
                                                      }}
                                                      className="text-primary mr-1"
                                                    >
                                                      <u>View</u>
                                                    </span>
                                                  </>
                                                )}
                                              </td>
                                              <td className="nowrap text-center">
                                                <div className="product-detail text-center">
                                                  <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                                    style={{
                                                      height: "100px",
                                                      width: "150px",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                              <td>
                                                <h5 className="font-size-14">
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      this.tog_static(item)
                                                    }
                                                    className="text-dark"
                                                  >
                                                    {item?.product?.name || ""}
                                                  </Link>
                                                </h5>
                                                <p className="mb-0">
                                                  <b className="text-dark">
                                                    Make :
                                                  </b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.make}
                                                  </span>
                                                </p>

                                                <p>
                                                  {" "}
                                                  <b className="text-dark">
                                                    Quantity :
                                                  </b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.originalqty}{" "}
                                                    {item?.unit?.name || ""}
                                                  </span>
                                                </p>
                                                <p>
                                                  <b className="text-dark">
                                                    Item Info :
                                                  </b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.item_info}
                                                  </span>
                                                </p>
                                              </td>
                                              <td className="text-center">
                                                {this.props.QRowData?.orderlocation?.name || "-"}
                                                {this.props.QRowData?.orderlocation && (
                                                  this.props.QRowData.orderlocation.image ||
                                                  this.props.QRowData.orderlocation.image2 ||
                                                  this.props.QRowData.orderlocation.image3
                                                ) && (
                                                    <Button
                                                      color="info"
                                                      size="sm"
                                                      className="ml-2"
                                                      onClick={() => {
                                                        console.log("📍 [Quotation View Click] orderlocation:", JSON.stringify(this.props.QRowData.orderlocation, null, 2));
                                                        this.setState({
                                                          showImageModal: true,
                                                          selectedOrderLocation:
                                                            this.props.QRowData.orderlocation,
                                                        });
                                                      }}
                                                    >
                                                      View
                                                    </Button>
                                                  )}
                                              </td>
                                              <td className=" text-center">
                                                {item.qty}{" "}
                                                {item?.unit?.name || ""}
                                              </td>
                                              {/* <td className="nowrap text-center">
                                              {item.qualities?.length > 0
                                                ? item.qualities
                                                    .map((q) => q.name)
                                                    .join(", ")
                                                : "-"}
                                            </td> */}
                                              <td
                                                className="text-center"
                                                style={{
                                                  minWidth: "150px",
                                                }}
                                              >
                                                <InputGroup>
                                                  <Input
                                                    placeholder="Item Base Price"
                                                    min={0}
                                                    type="number"
                                                    id="baseprice"
                                                    value={item?.baseprice}
                                                  />
                                                  <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                      &#8377;
                                                    </InputGroupText>
                                                  </InputGroupAddon>
                                                </InputGroup>
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{
                                                  minWidth: "120px",
                                                }}
                                              >
                                                <InputGroup>
                                                  <Input
                                                    placeholder="Item discountpercent"
                                                    min={0}
                                                    type="number"
                                                    id="baseprice"
                                                    value={item.discountpercent}
                                                  />
                                                  <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                      %
                                                    </InputGroupText>
                                                  </InputGroupAddon>
                                                </InputGroup>
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{
                                                  minWidth: "150px",
                                                }}
                                              >
                                                <InputGroup>
                                                  <Input
                                                    placeholder="Item Price"
                                                    min={0}
                                                    type="number"
                                                    id="price"
                                                    value={item.price}
                                                    readOnly
                                                    disabled={true}
                                                  />
                                                  <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                      &#8377;
                                                    </InputGroupText>
                                                  </InputGroupAddon>
                                                </InputGroup>

                                                <p>
                                                  Item Discount: &#8377;{" "}
                                                  {item.discount}
                                                </p>
                                              </td>
                                              {/* <td className=" text-center">
                                              <div>
                                                <InputGroup>
                                                  <Input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Base Price"
                                                    value={item.baseprice}
                                                    readOnly
                                                    disabled={true}
                                                  />
                                                  <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                      {item.discountpercent} %
                                                    </InputGroupText>
                                                  </InputGroupAddon>
                                                </InputGroup>
                                              </div>
                                            </td>
                                            <td className=" text-center">
                                              <div>
                                                <InputGroup>
                                                  <Input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Price"
                                                    value={item.price}
                                                    readOnly
                                                    disabled={true}
                                                  />
                                                  <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                      &#8377;
                                                    </InputGroupText>
                                                  </InputGroupAddon>
                                                </InputGroup>
                                              </div>
                                            </td> */}
                                              <td className=" text-center">
                                                <div>
                                                  <FormGroup className="mb-0">
                                                    <Input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Taxtype"
                                                      value={
                                                        parseInt(
                                                          item.taxtype,
                                                        ) === 1
                                                          ? "Inclusive"
                                                          : "Exclusive"
                                                      }
                                                      // value={item.taxtype}
                                                      readOnly
                                                      disabled={true}
                                                    />
                                                  </FormGroup>{" "}
                                                </div>
                                              </td>
                                              <td className="nowrap text-center">
                                                <div>
                                                  <FormGroup className="mb-0">
                                                    <Input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Taxtype"
                                                      value={
                                                        item?.tax?.name || ""
                                                      }
                                                      readOnly
                                                      disabled={true}
                                                    />
                                                  </FormGroup>{" "}
                                                  <p>
                                                    Tax Amount: &#8377;{" "}
                                                    {item.taxamount}
                                                  </p>
                                                </div>
                                              </td>
                                              <td className="nowrap">
                                                <div>
                                                  <InputGroup>
                                                    <Input
                                                      type="number"
                                                      className="form-control"
                                                      placeholder="Gross Value"
                                                      value={item.gross}
                                                      readOnly
                                                      disabled={true}
                                                    />
                                                    <InputGroupAddon addonType="append">
                                                      <InputGroupText>
                                                        &#8377;
                                                      </InputGroupText>
                                                    </InputGroupAddon>
                                                  </InputGroup>
                                                </div>
                                              </td>
                                            </tr>

                                            <tr>
                                              <td colSpan="8" className="p-2">
                                                <b>Qualities:</b>{" "}
                                                <span className="font-weight-medium">
                                                  {item.qualities?.length > 0
                                                    ? item.qualities
                                                        .map((q) => q.name)
                                                        .join(", ")
                                                    : "-"}
                                                </span>
                                              </td>
                                            </tr>
                                          </React.Fragment>
                                        ),
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>Order Location Document:</h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({ showImageModal: false })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {(() => {
                                    const loc =
                                      this.state.selectedOrderLocation;
                                    console.log(
                                      "📍 [RFQ Image Render] loc:",
                                      JSON.stringify(loc, null, 2),
                                    );
                                    let activeImage = null;
                                    if (loc?.send_flag1 && loc?.image)
                                      activeImage = loc.image;
                                    else if (loc?.send_flag2 && loc?.image2)
                                      activeImage = loc.image2;
                                    else if (loc?.send_flag3 && loc?.image3)
                                      activeImage = loc.image3;
                                    else
                                      activeImage = loc?.image || loc?.image2 || loc?.image3;
                                    console.log(
                                      "📍 [RFQ Image Render] activeImage:",
                                      activeImage,
                                    );

                                    if (!activeImage) {
                                      return (
                                        <p style={{ padding: 10 }}>
                                          No document available
                                        </p>
                                      );
                                    }

                                    let cleanUrl = activeImage.trim();
                                    try {
                                      const parsed = new URL(cleanUrl);
                                      cleanUrl =
                                        parsed.pathname + parsed.search;
                                    } catch (_) {
                                      if (!cleanUrl.startsWith("/")) {
                                        cleanUrl = "/" + cleanUrl;
                                      }
                                    }

                                    const isPdf = /\.pdf(\?.*)?$/i.test(
                                      cleanUrl,
                                    );

                                    return isPdf ? (
                                      <PdfViewer url={cleanUrl} />
                                    ) : (
                                      <img
                                        src={cleanUrl}
                                        alt="Order Location"
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                        }}
                                      />
                                    );
                                  })()}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <Row>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1 ">
                              <i className="mdi mdi-alert-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Terms & Conditions
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Terms & Conditions"
                                    rows="7"
                                    disabled={true}
                                    value={this.props.QRowData.terms}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={6}>
                          <Card className="p-0 ">
                            <CardHeader className="bg-transparent border-bottom p-1">
                              <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                              <h5 className="card-title-15 d-inline-block">
                                Other Details
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2 ">
                              <div>
                                <FormGroup className="mb-0">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Enter Details"
                                    // maxLength="225"
                                    rows="7"
                                    disabled={true}
                                    value={this.props.QRowData.description}
                                  />
                                </FormGroup>{" "}
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>

                      {/* <CardFooter className="bg-transparent p-1">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/quotationdashboard"
                          >
                            Back
                          </Button>
                         
                        </div>
                      </CardFooter> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="QLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            <GetPIDetails />
            <GetMRDetails />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { QRowData, loading } = state.Quotation;
  return {
    QRowData,
    loading,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    getQuotationData,
    QuotationPdf,
    getMRCodeDetails,
    getPICodeDetails,
    PIDetailsModel_open,
    MRDetailsModel_open,
  })(Quotation),
);
